import { integrationsSelector } from "src/store/plaidIntegration/selector";
import { isImpersonationSessionSelector } from "src/store/system/selector";
import { poshmarkSyncWithCheck } from "./poshmark";
import { mercariSyncWithCheck } from "./mercari";
import { whatnotSyncWithCheck } from "./whatnot";
import { vintedSyncWithCheck } from "./vinted";
import { depopSyncWithCheck } from "./depop";
import { integrationSyncEntrySelector } from "../selector";

export * from "./actions";

export function syncWithCheck(integrationId: string) {
  return (dispatch, getState) => {
    // Accountant / support impersonation sessions cannot trigger client-side syncs.
    if (isImpersonationSessionSelector(getState())) return;
    const integrations = integrationsSelector(getState());
    const integration = integrations.find((i) => i.id === integrationId);
    if (integration) {
      const status = integrationSyncEntrySelector(getState(), integration.type);
      if (status) return;

      if (integration.type === "poshmark")
        dispatch(poshmarkSyncWithCheck(integrationId));
      else if (integration.type === "mercari")
        dispatch(mercariSyncWithCheck(integrationId));
      else if (integration.type === "what-not")
        dispatch(whatnotSyncWithCheck(integrationId));
      else if (integration.type === "vinted")
        dispatch(vintedSyncWithCheck(integrationId));
      else if (integration.type === "depop")
        dispatch(depopSyncWithCheck(integrationId));
    }
  };
}
